import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaTachometerAlt,
  FaClipboardList,
  FaWrench,
  FaChevronLeft,
  FaChevronRight,
  FaExclamationTriangle
} from "react-icons/fa";
import '../styles/Sidebar.css';

const LabTechnicianSidebar = ({ user }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className={`lab-tech-sidebar ${isCollapsed ? 'collapsed' : ''}`}>

      {/* Toggle Collapse Button */}
      <button
        className="sidebar-toggle-btn"
        onClick={() => setIsCollapsed(!isCollapsed)}
        title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
      </button>

      {/* Header / Logo */}
     

      {/* Navigation */}
      <nav className="sidebar-nav">
        <NavLink to="/lab-dashboard" className="nav-btn" title="Dashboard">
          <FaTachometerAlt className="nav-icon" />
          {!isCollapsed && <span>Dashboard</span>}
        </NavLink>

        <NavLink to="/lab-dashboard/issues" className="nav-btn" title="Issues">
          <FaClipboardList className="nav-icon" />
          {!isCollapsed && <span>Issues</span>}
        </NavLink>

        <NavLink to="/maintenance-requests" className="nav-btn" title="Maintenance Requests">
          <FaWrench className="nav-icon" />
          {!isCollapsed && <span>Maintenance Requests</span>}
        </NavLink>

        <NavLink to="/compliance-management" className="nav-btn" title="Compliance Management">
          <FaExclamationTriangle className="nav-icon" style={{ color: '#dc2626' }} />
          {!isCollapsed && <span>Compliance Management</span>}
        </NavLink>
      </nav>
    </div>
  );
};

export default LabTechnicianSidebar;